












import { Vue, Component, PropSync } from 'vue-property-decorator'
import { Question, TextAnswer } from '../../controllers/Chat'
import { isAnswerValid } from '@/modules/chatbot/controllers/AnswerValidators'

@Component
export default class TextAnswerComponent extends Vue {
    @PropSync('question', { required: true, type: Question })
    syncQuestion: Question

    // The errorState is set to false, everytime the user inputs something new, so they don't get confuse,
    // this is done with the Input event on v-text-field
    errorState: boolean = false

    async addText () {
      let textAnswer = this.syncQuestion.answer as TextAnswer
      let validators = textAnswer.validators

      let results = await isAnswerValid(validators, textAnswer.value)
      let isValid = results[0]
      let errorMessages = results[1]

      if (isValid) {
        this.$emit('validAnswer', textAnswer.value)
      } else {
        this.errorState = true
        this.$emit('invalidAnswer', errorMessages[0])
      }

    }
}
